// extracted by mini-css-extract-plugin
export default {"smTd":"Inquiries_smTd__OGG5Y","priceTd":"Inquiries_priceTd__gX48y","statusLabel":"Inquiries_statusLabel__ktCmP"};